import React from 'react';
import Editor, { default as MdEditorLite, Plugins } from 'react-markdown-editor-lite';
import 'react-markdown-editor-lite/lib/index.css';
import './md-editor-styles.css';
import { mdParser } from './mdParser';
// import { TestPlugin } from "./plugins/TestPlugin";
// import { AttachmentPlugin } from "./plugins/AttachmentPlugin";


MdEditorLite.addLocale('ru-RU', {
    clearTip: 'Вы уверены, что хотите очистить весь контент?',
    btnHeader: 'Заголовок',
    btnClear: 'Очистить',
    btnBold: 'Жирный',
    btnItalic: 'Курсив',
    btnUnderline: 'Подчеркнуть',
    btnStrikethrough: 'Перечеркнуть',
    btnUnordered: 'Маркированный список',
    btnOrdered: 'Нумерованный список',
    btnQuote: 'Цитата',
    btnLineBreak: 'Разрыв строки',
    btnInlineCode: 'Inline код',
    btnCode: 'Код',
    btnTable: 'Таблица',
    btnImage: 'Изображение',
    btnLink: 'ССылка',
    btnUndo: 'Отменить',
    btnRedo: 'Повторить',
    btnFullScreen: 'На полный экран',
    btnExitFullScreen: 'Выход из полноэкранного режима',
    btnModeEditor: 'Редактор',
    btnModePreview: 'Просмотр',
    btnModeAll: 'Редактор и просмотр',
    selectTabMap: 'Actual input when typing a Tab key',
    tab: 'Tab',
    spaces: 'Spaces',
});

MdEditorLite.useLocale('ru-RU');

// Отключениe кнопок
MdEditorLite.unuse(Plugins.BlockQuote);
MdEditorLite.unuse(Plugins.BlockWrap);
MdEditorLite.unuse(Plugins.BlockCodeInline);
MdEditorLite.unuse(Plugins.BlockCodeBlock);
MdEditorLite.unuse(Plugins.Table);
MdEditorLite.unuse(Plugins.Image);
MdEditorLite.unuse(Plugins.Link);

// MdEditorLite.use(TestPlugin, { insertText: 'tap tap tap ' });
// MdEditorLite.use(AttachmentPlugin, { insertFormat: '![:url]()' });

export type MdEditorProps = Partial<MdEditorLite['props']> & {
    editorRef?: React.RefObject<Editor>,
};

export const MdEditor = (props: MdEditorProps) => {
    const renderHTML = (text: string) => mdParser.render(text ?? '');

    return (
        <MdEditorLite
            ref={props.editorRef}
            renderHTML={renderHTML}
            canView={{
                menu: true,
                md: true,
                html: true,
                fullScreen: true,
                hideMenu: true,
                both: true,
            }}
            view={{
                menu: true,
                md: true,
                html: false,
            }}
            {...props}
            style={{
                height: '200px',
                width: '100%',
                ...(props.style || {}),
            }}
        />
    );
}